import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback, useRef } from "react";
import { Link, useParams, NavLink, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import { nanoid } from "nanoid";
import { useAppDispatch, useAppSelector } from "../../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { getAllSupplierInformation } from "../../../redux/handlers/logic/getAllSupplierInformation.handler";
import { defaultOption } from "constants/ui/options";
import { getAllGroupOfSupplier } from "../../../redux/handlers/logic/getAllGroupOfSupplier.handler";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import CurrencyFormat from "react-currency-format";
import DataTable from "@jcognard-actinvision/react-data-table-component";
import Datatablenoresults from "layouts/Datatablenoresults";
import CheckboxTable from "fragments/CheckboxTable";
import DownloadExcel from "utils/DownloadExcel";
import { useReactToPrint } from "react-to-print";
import PrintIcon from "@mui/icons-material/Print";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { utils, writeFileXLSX } from "xlsx";
import moment from "moment";
import { mappingReportPurchaseOrderData } from "utils/HelperReportPurchaseOrderFunction";
import { getAllReportPurchaseOrder } from "../../../redux/handlers/report/getAllReportPurchaseOrder.handler";
export function ReportBuyOrder() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), tabledata = _useState[0], setTabledata = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), optionsGroupOfSuplier = _useState1[0], setOptionsGroupOfSuplier = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), selectedGroupOfSuplierID = _useState2[0], setSelectedGroupOfSuplierID = _useState2[1];
    var _useState3 = _sliced_to_array(useState(defaultOption), 2), groupOfSupplier = _useState3[0], setGroupOfSupplier = _useState3[1];
    var _useState4 = _sliced_to_array(useState({
        startDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD")
    }), 2), reportDateRange = _useState4[0], setReportDateRange = _useState4[1];
    var getAllReportPurchaseOrderReducer = useAppSelector(function(state) {
        return state.getAllReportPurchaseOrderReducer;
    });
    var getReportData = function() {
        var queryParams = {
            startDate: reportDateRange.startDate,
            endDate: reportDateRange.endDate
        };
        console.log("Params", queryParams);
        dispatch(getAllReportPurchaseOrder({
            queryParams: queryParams,
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var loadAllMsts = function() {
        dispatch(getAllGroupOfSupplier());
    };
    var gettableData = function() {
        dispatch(getAllSupplierInformation({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        loadAllMsts();
        gettableData();
    }, []);
    useEffect(function() {
        setIsLoading(getAllReportPurchaseOrderReducer.isFetching);
        if (getAllReportPurchaseOrderReducer.data) {
            var mappingData = mappingReportPurchaseOrderData(getAllReportPurchaseOrderReducer.data.data);
            setTabledata(mappingData);
        }
    }, [
        getAllReportPurchaseOrderReducer
    ]);
    /* useEffect(() => {
    setTabledata([{
      date:"10/10/2024",
      productPrice:96.30,
      discount:20.00,
      productPriceIncVat:76.30,
      productPriceExVat:71.31,
      vat:4.99,
      product:2,
      bill:1,
      productReturnBill:0,
      productReturnPrice:0.00
    },{
      date:"10/10/2024",
      productPrice:96.30,
      discount:20.00,
      productPriceIncVat:76.30,
      productPriceExVat:71.31,
      vat:4.99,
      product:2,
      bill:1,
      productReturnBill:0,
      productReturnPrice:0.00
    }])

  }, []); */ var columns = [
        {
            name: /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: ""
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center",
                        children: "วันที่"
                    })
                ]
            }),
            minWidth: "290px",
            selector: function(row) {
                return row.date;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    children: row.date
                });
            }
        },
        {
            name: /*#__PURE__*/ _jsxs("div", {
                className: "text-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: "มูลค่าสินค้าก่อน"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: "ส่วนลด"
                    })
                ]
            }),
            selector: function(row) {
                return row.productPrice;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        " ",
                        /*#__PURE__*/ _jsx(CurrencyFormatC, {
                            val: row.productPrice
                        }),
                        " "
                    ]
                });
            },
            footerContent: function(rows) {
                var total = rows.reduce(function(val, row) {
                    return val + row.productPrice;
                }, 0);
                return /*#__PURE__*/ _jsx(CurrencyFormatC, {
                    val: total
                });
            },
            width: "150px",
            center: true
        },
        {
            name: "ส่วนลด",
            selector: function(row) {
                return row.discount;
            },
            center: true,
            width: "140px",
            footerContent: function(rows) {
                var total = rows.reduce(function(val, row) {
                    return val + row.discount;
                }, 0);
                return /*#__PURE__*/ _jsx(CurrencyFormatC, {
                    val: total
                });
            }
        },
        {
            name: /*#__PURE__*/ _jsxs("div", {
                className: "text-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: "ยอดสุทธิ"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: "Inc.Vat"
                    })
                ]
            }),
            selector: function(row) {
                return row.productPriceIncVat;
            },
            width: "140px",
            center: true,
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        " ",
                        /*#__PURE__*/ _jsx(CurrencyFormatC, {
                            val: row.productPriceIncVat
                        }),
                        " "
                    ]
                });
            },
            footerContent: function(rows) {
                var total = rows.reduce(function(val, row) {
                    return val + row.productPriceIncVat;
                }, 0);
                return /*#__PURE__*/ _jsx(CurrencyFormatC, {
                    val: total
                });
            }
        },
        {
            name: /*#__PURE__*/ _jsxs("div", {
                className: "text-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: "มูลค่าสินค้า"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: "Ex.Vat"
                    })
                ]
            }),
            selector: function(row) {
                return row.productPriceExVat;
            },
            width: "140px",
            center: true,
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        " ",
                        /*#__PURE__*/ _jsx(CurrencyFormatC, {
                            val: row.productPriceExVat
                        }),
                        " "
                    ]
                });
            },
            footerContent: function(rows) {
                var total = rows.reduce(function(val, row) {
                    return val + row.productPriceExVat;
                }, 0);
                return /*#__PURE__*/ _jsx(CurrencyFormatC, {
                    val: total
                });
            }
        },
        {
            name: "ภาษีมูลค่าเพิ่ม",
            selector: function(row) {
                return row.vat;
            },
            center: true,
            width: "140px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        " ",
                        /*#__PURE__*/ _jsx(CurrencyFormatC, {
                            val: row.vat
                        }),
                        " "
                    ]
                });
            },
            footerContent: function(rows) {
                var total = rows.reduce(function(val, row) {
                    return val + row.vat;
                }, 0);
                return /*#__PURE__*/ _jsx(CurrencyFormatC, {
                    val: total
                });
            }
        },
        {
            name: "จำนวนสินค้า",
            selector: function(row) {
                return row.product;
            },
            center: true,
            width: "140px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        " ",
                        /*#__PURE__*/ _jsx(CurrencyFormatC, {
                            val: row.product,
                            decimal: 0
                        }),
                        " "
                    ]
                });
            },
            footerContent: function(rows) {
                var total = rows.reduce(function(val, row) {
                    return val + row.product;
                }, 0);
                return /*#__PURE__*/ _jsx(CurrencyFormatC, {
                    val: total,
                    decimal: 0
                });
            }
        },
        {
            name: "จำนวนบิล",
            selector: function(row) {
                return row.bill;
            },
            center: true,
            width: "140px",
            footerContent: function(rows) {
                var total = rows.reduce(function(val, row) {
                    return val + row.bill;
                }, 0);
                return total;
            }
        },
        {
            name: /*#__PURE__*/ _jsxs("div", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-[#DC0000] h-[40px] pt-2 ml-[110px]",
                        style: {
                            position: "absolute",
                            whiteSpace: "nowrap",
                            zIndex: 999
                        },
                        children: "ส่งคืนสินค้า"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-[#DC0000]  h-[40px] border-b-[1px] border-[#E5E5E5]"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center text-[#DC0000] pt-2 pb-2 border-r-[1px] border-[#E5E5E5] ",
                        children: "จำนวนบิล"
                    })
                ]
            }),
            selector: function(row) {
                return row.productReturnBill;
            },
            center: true,
            width: "140px",
            footerContent: function(rows) {
                var total = rows.reduce(function(val, row) {
                    return val + row.productReturnBill;
                }, 0);
                return total;
            }
        },
        {
            name: /*#__PURE__*/ _jsxs("div", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-[#DC0000] h-[40px] border-b-[1px] border-[#E5E5E5]"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center text-[#DC0000]  pt-2 pb-2",
                        children: "มูลค่าสินค้า"
                    })
                ]
            }),
            selector: function(row) {
                return row.productReturnPrice;
            },
            center: true,
            width: "130px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        " ",
                        /*#__PURE__*/ _jsx(CurrencyFormatC, {
                            val: row.productReturnPrice
                        }),
                        " "
                    ]
                });
            },
            footerContent: function(rows) {
                var total = rows.reduce(function(val, row) {
                    return val + row.productReturnPrice;
                }, 0);
                return /*#__PURE__*/ _jsx(CurrencyFormatC, {
                    val: total
                });
            }
        }
    ];
    var _useState5 = _sliced_to_array(useState(""), 2), filterText = _useState5[0], setFilterText = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), filteredItems = _useState6[0], setFilteredItems = _useState6[1];
    var CurrencyFormatC = function(param) {
        var val = param.val, _param_decimal = param.decimal, decimal = _param_decimal === void 0 ? 2 : _param_decimal;
        return /*#__PURE__*/ _jsx(CurrencyFormat, {
            value: val,
            decimalScale: decimal,
            fixedDecimalScale: true,
            displayType: "text",
            thousandSeparator: true,
            prefix: ""
        });
    };
    var contentRef = useRef(null);
    var handlePrint = useReactToPrint({
        contentRef: contentRef
    });
    var download = function(data, filename) {
        if (data) {
            var ws = utils.json_to_sheet(data);
            var wb = utils.book_new();
            utils.book_append_sheet(wb, ws, filename);
            writeFileXLSX(wb, filename + ".xlsx");
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx("nav", {
                    "aria-label": "breadcrumb",
                    className: "mt-2 mb-4",
                    children: /*#__PURE__*/ _jsxs("ol", {
                        className: "breadcrumb fs-16 ps-0",
                        children: [
                            /*#__PURE__*/ _jsx("li", {
                                className: "breadcrumb-item ",
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: "#",
                                    className: "tc-7  text-decoration-none",
                                    children: "รายงาน"
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                className: "breadcrumb-item ",
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: "#",
                                    className: "tc-7  text-decoration-none",
                                    children: "รายงานการซื้อ"
                                })
                            }),
                            /*#__PURE__*/ _jsxs("li", {
                                className: "breadcrumb-item active tc-1 ",
                                "aria-current": "page",
                                children: [
                                    " ",
                                    "รายงานมูลค่าการซื้อรายวันตามใบสั่งซื้อ",
                                    " "
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-2 mb-4",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "card-body px-0 pt-4 pb-0",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "mb-2 text-[#4C4E64]/[0.87] font-semibold text-lg px-4",
                            children: "ตัวเลือก"
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center px-4 mb-0 flex-wrap",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "w-[300px] mr-4",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-3 form-st-3 pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                className: "mb-1",
                                                children: [
                                                    "เลือกช่วงวันที่",
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx(DateRangePicker, {
                                                initialSettings: {
                                                    startDate: moment().subtract(30, "days").format("DD/MM/YYYY"),
                                                    endDate: moment().format("DD/MM/YYYY"),
                                                    locale: {
                                                        format: "DD/MM/YYYY"
                                                    }
                                                },
                                                onEvent: function(e, picker) {
                                                    setReportDateRange({
                                                        startDate: picker.startDate.format("YYYY-MM-DD"),
                                                        endDate: picker.endDate.format("YYYY-MM-DD")
                                                    });
                                                },
                                                children: /*#__PURE__*/ _jsx("input", {
                                                    type: "text",
                                                    className: "form-control  h-[44px]"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    onClick: function(e) {
                                        getReportData();
                                    },
                                    className: "btn btn btn-st-7 mb-2 px-4 ",
                                    children: "execute"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "pb-3 mb-2",
                children: [
                    /*#__PURE__*/ _jsx("button", {
                        className: "btn btn-export-st-2 me-auto ",
                        onClick: function() {
                            return download(tabledata, "report_by_po_".concat(moment().format("YYYY_MM_DD")));
                        },
                        children: "Export"
                    }),
                    /*#__PURE__*/ _jsxs(Button, {
                        type: "button",
                        className: "btn-st-8 fs-14 border !border-[#6d788d80] h-[39px] px-3 ml-3 !bg-[#FFF] text-[#6D788D]",
                        onClick: handlePrint,
                        children: [
                            /*#__PURE__*/ _jsx(PrintIcon, {
                                className: "me-2"
                            }),
                            " พิมพ์ข้อมูล"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "printContent",
                ref: contentRef,
                children: /*#__PURE__*/ _jsx("div", {
                    className: "table-custom-2 shadow overflow-hidden rounded-xl",
                    children: /*#__PURE__*/ _jsx(DataTable, {
                        data: tabledata,
                        columns: columns,
                        selectableRows: true,
                        PerPage: 10,
                        selectableRowsComponent: CheckboxTable,
                        noDataComponent: /*#__PURE__*/ _jsx(Datatablenoresults, {}),
                        footer: tabledata,
                        showFooter: true,
                        customStyles: customStyles
                    })
                })
            })
        ]
    });
}
var customStyles = {
    rows: {
        style: {
            minHeight: "52px",
            border: 0
        }
    },
    headCells: {
        style: {
            paddingLeft: "15px",
            paddingRight: "15px",
            color: "rgba(76, 78, 100, 0.87)",
            fontFamily: "Sarabun",
            fontSize: "16px",
            background: " #F5F5F7",
            paddingTop: "15px",
            paddingBottom: "15px",
            borderTop: "1px solid #E5E5E5",
            borderRight: "1px solid #E5E5E5"
        }
    },
    cells: {
        style: {
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingTop: "10px",
            paddingBottom: "10px",
            color: "rgba(76, 78, 100, 0.87)",
            fontFamily: "Sarabun",
            fontSize: "16px",
            fontWeight: "300"
        }
    }
};
var paginationComponentOptions = {
    rowsPerPageText: "จำนวนรายการต่อหน้า",
    rangeSeparatorText: "of",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos"
};
